import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

interface DownloadCMSAssetResponse {
  fileUrl: string;
}

export const getDownloadURLQueryKey = (assetId: string) => ['cmsAssetDownloadURL', assetId];

const getDownloadURL = (assetId: string): Promise<DownloadCMSAssetResponse> =>
  FetchPromise.get(`${CMS_API_ROOT_URL}/file/${assetId}/download`);

export const useGetDownloadURL = (assetId: string, queryOptions: { enabled: boolean }) =>
  useQuery<DownloadCMSAssetResponse, JQuery.jqXHR>({
    queryKey: getDownloadURLQueryKey(assetId),
    queryFn: () => getDownloadURL(assetId),
    enabled: queryOptions.enabled,
  });
